import { create } from 'zustand';
import { createSelectors, StoreName, withDevtools } from '../config';
import {
	createIssueDocumentationOperationsSlice,
	IssueDocumentationOperationsSlice,
} from './slices/issueDocumentationOperations';
import {
	createIssueParametersSlice,
	IssueParametersSlice,
} from './slices/issueParameters';
import { createIssuesSlice, IssuesSlice } from './slices/issues';
import {
	createIssueLinkedDocumentationSlice,
	IssueLinkedDocumentationSlice,
} from './slices/issueLinkedDocumentation';
import {
	createIssueChangelogSlice,
	IssueChangelogSlice,
} from './slices/issueChangelog';
import { createIssueNavigationSlice, IssueNavigationSlice } from './slices/issueNavigation';
import { createIssuesOnMapSlice, IssuesOnMapSlice } from './slices/issuesOnMap';
import { createIssuesOfInspectionSlice, IssuesOfInspectionSlice } from './slices/issuesOfInspection';
import { createCurrentIssueSlice, CurrentIssueSlice } from './slices/currentIssue';

/** Every issue data set of the page, one slice each. */
export type IssueStoreState = IssuesSlice &
	IssueNavigationSlice &
	IssuesOnMapSlice &
	IssuesOfInspectionSlice &
	IssueParametersSlice &
	IssueDocumentationOperationsSlice &
	IssueLinkedDocumentationSlice &
	IssueChangelogSlice &
	CurrentIssueSlice & {
		reset: () => void;
	};

export const useIssueStore = createSelectors(
	create<IssueStoreState>()(
		withDevtools(
			(set, get, store) => ({
				...createIssuesSlice(set, get, store),
				...createIssueNavigationSlice(set, get, store),
				...createIssuesOnMapSlice(set, get, store),
				...createIssuesOfInspectionSlice(set, get, store),
				...createIssueParametersSlice(set, get, store),
				...createIssueDocumentationOperationsSlice(set, get, store),
				...createIssueLinkedDocumentationSlice(set, get, store),
				...createIssueChangelogSlice(set, get, store),
				...createCurrentIssueSlice(set, get, store),
				reset: () => {
					const state = get();
					state.resetIssues();
					state.resetIssueNavigation();
					state.resetIssuesOnMap();
					state.resetInspectionIssues();
					state.resetIssueDocumentationOperations();
					state.resetLinkedDocumentation();
					state.resetIssueChangelog();
					state.resetCurrentIssue();
				},
			}),
			StoreName.Issues
		)
	)
);

